export { ToastComponent } from "./src/toast.component";
export { ToasterContainerComponent } from "./src/toaster-container.component";
export { ToasterService } from "./src/toaster.service";
export { ToasterConfig } from "./src/toaster-config";
export { BodyOutputType } from "./src/bodyOutputType";
export { ToasterModule } from "./src/toaster.module";
//# sourceMappingURL=angular2-toaster.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular2-toaster/angular2-toaster.js
// module id = ./node_modules/angular2-toaster/angular2-toaster.js
// module chunks = vendor